import { Link } from 'react-router-dom';
import { ArrowUpRight, GraduationCap, GitBranch, School, Rocket } from 'lucide-react';
import { Reveal, SectionHeading } from '../Reveal';
import { AUDIENCES } from '../../data/content';

const ICONS = { GraduationCap, GitBranch, School, Rocket };

const WhoWeHelp = () => (
  <section className="bg-mist py-24 md:py-32" data-testid="who-we-help-section">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <SectionHeading
        index="02"
        overline="Who We Help"
        title="Guidance for Every Stage of Your Journey"
        description="Whether you're in 8th grade or eight years into your career, there's a clear next step waiting for you."
      />

      <div className="mt-16 grid gap-6 md:grid-cols-12 md:gap-8">
        {AUDIENCES.map((a, i) => {
          const Icon = ICONS[a.icon];
          const wide = i === 0 || i === 3;
          return (
            <Reveal key={a.title} delay={0.08 * i} className={wide ? 'md:col-span-7' : 'md:col-span-5'}>
              <div
                className="group flex h-full flex-col rounded-3xl border border-line bg-white p-8 shadow-card transition-[box-shadow,transform] duration-300 hover:-translate-y-1.5 hover:shadow-card-hover md:p-10"
                data-testid={`audience-card-${a.title.toLowerCase().replace(/[\s&]+/g, '-')}`}
              >
                <div className="flex items-start justify-between">
                  <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-navy/5 text-navy transition-colors duration-300 group-hover:bg-coral group-hover:text-white">
                    <Icon className="h-6 w-6" />
                  </span>
                  <span className="rounded-full bg-coral/10 px-3.5 py-1.5 text-xs font-bold uppercase tracking-wider text-coral">
                    {a.tag}
                  </span>
                </div>
                <h3 className="mt-7 font-display text-xl font-semibold text-navy md:text-2xl">{a.title}</h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-600 md:text-base">{a.text}</p>
                <Link
                  to={a.to}
                  data-testid={`audience-cta-${a.title.toLowerCase().replace(/[\s&]+/g, '-')}`}
                  className="mt-7 inline-flex items-center gap-2 text-sm font-bold text-navy transition-colors group-hover:text-coral"
                >
                  {a.cta}
                  <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </Link>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);

export default WhoWeHelp;
